import { render, staticRenderFns } from "./ColorLinesRegistryList.vue?vue&type=template&id=ec4d921c"
import script from "./ColorLinesRegistryList.vue?vue&type=script&lang=js"
export * from "./ColorLinesRegistryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports